import { render, staticRenderFns } from "./imprSupple.vue?vue&type=template&id=089a90fb"
import script from "./imprSupple.vue?vue&type=script&lang=js"
export * from "./imprSupple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('089a90fb')) {
      api.createRecord('089a90fb', component.options)
    } else {
      api.reload('089a90fb', component.options)
    }
    module.hot.accept("./imprSupple.vue?vue&type=template&id=089a90fb", function () {
      api.rerender('089a90fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/imprSupple.vue"
export default component.exports